import {HttpStatusCode, AxiosResponseHeaders, RawAxiosResponseHeaders} from "axios";
import IResponse from "@/types/response";

class DataResponse implements IResponse {
    status: HttpStatusCode;
    headers: RawAxiosResponseHeaders | AxiosResponseHeaders;
    data?: any;

    constructor({status, headers, data}: IResponse) {
        this.status = status;
        this.headers = headers;
        try {
            this.data = JSON.parse(JSON.stringify(data))?.data || null
        } catch (e) {
            console.error(e)
        }
    }
}

export default DataResponse;